import * as app from "./definitions/app";
import * as users from "./definitions/users";
import * as graphs from "./definitions/graphs";
import * as reports from "./definitions/reports";
import * as security from "./definitions/security";
import * as requests from "./definitions/requests";
import * as companies from "./definitions/companies";
import * as customers from "./definitions/customers";
import * as deployments from "./definitions/deployments";
import * as bugreporting from "./definitions/bugreporting";
import * as notifications from "./definitions/notifications";
import * as authentication from "./definitions/authentication";
import * as mfaAuthentication from "./definitions/mfaAuthentication";
import * as reviewReportSnapshots from "./definitions/reviewReportSnapshots";
import * as lambdaFunctions from "./definitions/lambdaFunctions";

export default [
	app.BranchCheck,
	app.MeanResponseTime,
	app.TotalCompanyCount,
	app.OneDayTotalRequestsCount,

	users.GetOne,
	users.GetUsers,
	users.GetUsersSearch,
	users.GetRecentUsers,
	users.fetchUpcomingNotifications,
	users.GetRecentlyDeactivatedUsers,

	companies.GetCompany,
	companies.SetIntegration,
	companies.CompaniesSearch,
	companies.GetCompanyUsers,
	companies.DeleteIntegration,
	companies.UpdateIntegration,
	companies.GetCompanySnapshot,
	companies.UpdateCompanySetting,
	companies.UpdateCompanyTaxAddress,
	companies.UpdateCompanySnapshot,
	companies.ExportEmployeeCsv,
	companies.ResetNotificationDefaults,
	companies.copyStagingData,
	companies.RunReportingETL,
	companies.ExportGoalCsv,
	companies.GetCompanyInvoice,
	companies.UpdateCompanyInvoice,
	companies.CancelCompanyInvoice,
	companies.RecentlyDeletedObjects,
	companies.UndeleteReviewReport,
	companies.UndeleteReview,
	companies.SendSurveyManually,
	companies.SendReminderEmailsManually,

	customers.ClearCustomerBadLogins,

	authentication.Authenticate,
	authentication.AuthenticateGoogle,
	authentication.AuthenticateGoogleCallback,
	mfaAuthentication.MfaAuthenticate,

	requests.GetRequests,
	requests.GetRequestsPerMinute,

	graphs.GraphsFetch,
	graphs.GetMostActiveCompanies,
	graphs.GetMostActiveUtilization,

	reports.GetFlameChart,
	reports.GetRequestReport,

	notifications.fetchAdminDigests,
	notifications.fetchNotificationEmail,
	notifications.fetchNotificationEmails,
	notifications.fetchNotificationEvents,
	notifications.fetchNotificationSnapshots,
	notifications.fetchScheduledNotifications,
	notifications.fetchNotificationCounts,
	notifications.fetchScheduledNotification,

	reviewReportSnapshots.getReviewReportSnapshots,
	reviewReportSnapshots.getReviewReportsWithSnapshots,

	deployments.deployBranch,
	deployments.getDeployments,
	deployments.updateDeployment,
	deployments.getDeploymentInfo,
	deployments.teardownDeployment,

	bugreporting.GetBugReport,
	bugreporting.CreateBugReport,
	bugreporting.UploadScreenshot,
	bugreporting.GetPresignedPost,

	security.GetSecurityAudits,

	lambdaFunctions.GetLambdaFunctions,
];
